var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription",
    transform: "translate(-85 -590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147995",
    "data-name": "Rectangle 147995",
    width: 47,
    height: 46,
    rx: 10,
    transform: "translate(85 590)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_-Product-Icons",
    "data-name": "\\uD83D\\uDD0D-Product-Icons",
    transform: "translate(96.068 600.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_network_check_24_regular",
    transform: "translate(1.932 5.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": "\\uD83C\\uDFA8Color",
    d: "M10.24,15.665l6.4-8.675a.711.711,0,0,1,1.264.583l-.031.1L13.916,17.7A2.119,2.119,0,1,1,10.091,15.9l.071-.118h0l.078-.113,6.4-8.675Zm3.89-2.685-2.655,3.6-.041.064h0a.584.584,0,0,0,.228.794l.069.032h0a.584.584,0,0,0,.715-.243l.042-.085Zm-1.791-1.971-1.255,1.7A3.41,3.41,0,0,0,8.74,15.8a.768.768,0,0,1-1.534-.065,4.941,4.941,0,0,1,5.134-4.729ZM16.6,13.825a4.912,4.912,0,0,1,.473,1.91.768.768,0,0,1-1.408.454Zm-2.286-5.5-.991,1.342A6.386,6.386,0,0,0,6,14.184a.768.768,0,1,1-1.476-.422,7.921,7.921,0,0,1,9.79-5.433Zm3.592,2.188a7.826,7.826,0,0,1,.72.885,7.91,7.91,0,0,1,1.123,2.343.768.768,0,0,1-1.475.426,6.374,6.374,0,0,0-.905-1.888l-.1-.141.642-1.624Zm-1.6-4.646-.09.055a1.779,1.779,0,0,0-.344.3l-.1.122-.554.75a9.369,9.369,0,0,0-11.81,5.442.768.768,0,1,1-1.431-.556A10.9,10.9,0,0,1,16.311,5.872ZM19,7.47a10.974,10.974,0,0,1,3.3,4.51.768.768,0,0,1-1.43.559,9.451,9.451,0,0,0-2.381-3.485l.39-.986h0A1.782,1.782,0,0,0,19,7.47Z",
    transform: "translate(-1.932 -5.043)",
    fill: "#fdfdfd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.62f01d3ab5112eec7338937ed4365c77.svg";
export { ForwardRef as ReactComponent };